import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  media: {
    height: 140,
    backgroundSize: "contain",
  },
  outer: {
    width: `100%`,
    height: "16rem",
    margin: "0.625rem 0rem",
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "16rem",
      margin: "0",
    },
  },
  header: {
    margin: 0,
    [theme.breakpoints.up("md")]: {
      marginBottom: 20,
    },
  },
  inner: {
    height: "100%",
  },
}));

export default function MediaCard(props) {
  const classes = useStyles();

    let id = props.header.replace(/ & /g, ' and ')
    id = id.replace(/[()]/g, "")
    id = id.replace(/ + /g, "")

  return (
    <Card
      id={`navlink_${props.header === 'Performance Scorecard (CT)' ? 'Performance_Scorecard_CT' : id.split(" ").join("_")}`}
      raised={true}
      className={classes.outer}
    >
      <CardActionArea
        onClick={() => props.changeLocation(props.header)}
        className={classes.inner}
      >
        <CardContent style={{ width: "100%" }}>
          <Typography
            className={classes.header}
            variant="h2"
            component="h2"
            align="center"
          >
            {props.header}
          </Typography>
          <Grid container>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <Typography variant="body1" color="textSecondary">
                {props.text}
              </Typography>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <CardMedia
                className={classes.media}
                image={props.image}
                title={props.header}
              />
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
